import { metrics } from '@atlassian/browser-metrics';
import type { Metric } from '@atlassian/browser-metrics/types';

export const deadAirMetrics = {
	createDeadAirIntervalMetrics: (): Metric => {
		return metrics.interaction({
			key: 'ai-mate.dead-air-interval',
		});
	},
	createDeadAirMaxMetrics: (): Metric => {
		return metrics.interaction({
			key: 'ai-mate.dead-air-max',
		});
	},
};
